import "./App.css";
import { appRoutes } from "./app/routes/router";
import "./translation/translation";
import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

const router = createBrowserRouter(appRoutes);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
